import {GraftingProgramApplicationTypes} from "../constans/graftingProgramApplicationTypes";
import i18next from "i18next";
import {medicineTypes} from "../constans/medicine";

export function getTranslationByApplication(application) {
    switch (application) {
        case GraftingProgramApplicationTypes.AGE:
            return i18next.t("newSettings.breeding.graftingProgram.animalAge");
        case GraftingProgramApplicationTypes.INSEMINATION:
            return i18next.t(
                "newSettings.breeding.graftingProgram.dayAfterInsemination"
            );
        case GraftingProgramApplicationTypes.PARTURITION:
            return i18next.t(
                "newSettings.breeding.graftingProgram.dayAfterParturition"
            );
        case GraftingProgramApplicationTypes.SEPARATION:
            return i18next.t(
                "newSettings.breeding.graftingProgram.dayAfterSeparation"
            );
        case GraftingProgramApplicationTypes.INSERTION:
            return i18next.t(
                "newSettings.breeding.graftingProgram.dayAfterInsertion"
            );
        default:
            return i18next.t("notRecognized");
    }
}
export function treatmentTranslator(name) {
    switch (name) {
        case medicineTypes.STIMULATOR:
            return i18next.t("modals.medicineModal.stimulator");
        case medicineTypes.FORAGE:
            return i18next.t("medicalFeed");
        case medicineTypes.VACCINE:
            return i18next.t("modals.medicineModal.vaccine");
        case medicineTypes.VACCINE_IM:
            return i18next.t("modals.medicineModal.vaccine.im");
        case medicineTypes.VACCINE_SQ:
            return i18next.t("modals.medicineModal.vaccine.sq");
        case medicineTypes.VACCINE_IP:
            return i18next.t("modals.medicineModal.vaccine.ip");
        case medicineTypes.VACCINE_IV:
            return i18next.t("modals.medicineModal.vaccine.iv");
        case medicineTypes.VACCINE_IN:
            return i18next.t("modals.medicineModal.vaccine.in");
        case medicineTypes.DOSATRON:
            return i18next.t("dosatron");
        default:
            return i18next.t(name);
    }
}

export function isVaccine(value) {
    const list = [
        medicineTypes.VACCINE,
        medicineTypes.VACCINE_IM,
        medicineTypes.VACCINE_SQ,
        medicineTypes.VACCINE_IP,
        medicineTypes.VACCINE_IV,
        medicineTypes.VACCINE_IN,
    ];
    return list.includes(value);
}
export function isPCS(value) {
    const list = ["psc", "szt"];
    for (let item of list) {
        if (value.toLowerCase().includes(item)) {
            return true;
        }
    }
    return false;
}
